export interface LLMPlatform {
  id: string;
  name: string;
  region: 'domestic' | 'international';
  icon: string;
}

export const domesticLLMs: LLMPlatform[] = [
  { id: 'deepseek', name: 'DeepSeek', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=chat.deepseek.com&sz=128' },
  { id: 'doubao', name: '豆包', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=www.doubao.com&sz=128' },
  { id: 'kimi', name: 'Kimi', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=kimi.moonshot.cn&sz=128' },
  { id: 'tongyi', name: '通义千问', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=tongyi.aliyun.com&sz=128' },
  { id: 'zhipu', name: '智谱清言', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=chatglm.cn&sz=128' },
  { id: 'yuanbao', name: '元宝', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=yuanbao.tencent.com&sz=128' },
  { id: 'tiangong', name: '天工', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=www.tiangong.cn&sz=128' },
  { id: 'abab', name: 'ABAB', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=www.minimaxi.com&sz=128' },
  { id: 'wenxiaoyan', name: '文小言', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=yiyan.baidu.com&sz=128' },
  { id: 'baixiaoying', name: '百小应', region: 'domestic', icon: 'https://www.google.com/s2/favicons?domain=www.baichuan-ai.com&sz=128' },
];

export const internationalLLMs: LLMPlatform[] = [
  { id: 'chatgpt', name: 'ChatGPT', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=chatgpt.com&sz=128' },
  { id: 'claude', name: 'Claude', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=claude.ai&sz=128' },
  { id: 'gemini', name: 'Gemini', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=gemini.google.com&sz=128' },
  { id: 'copilot', name: 'Copilot', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=copilot.microsoft.com&sz=128' },
  { id: 'perplexity', name: 'Perplexity', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=www.perplexity.ai&sz=128' },
  { id: 'grok', name: 'Grok', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=grok.com&sz=128' },
  { id: 'meta', name: 'Meta AI', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=www.meta.ai&sz=128' },
  { id: 'lechat', name: 'Le Chat', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=chat.mistral.ai&sz=128' },
  { id: 'you', name: 'You.com', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=you.com&sz=128' },
  { id: 'pi', name: 'Pi', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=pi.ai&sz=128' },
  { id: 'poe', name: 'Poe', region: 'international', icon: 'https://www.google.com/s2/favicons?domain=poe.com&sz=128' },
];

export const allLLMPlatforms = {
  domestic: domesticLLMs,
  international: internationalLLMs,
};
